import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./contexts/AuthContext";
import { AppProvider } from "./contexts/AppContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";

import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import CurrencyMasterPage from "./pages/CurrencyMasterPage";
import EntitiesPage from "./pages/EntitiesPage";
import BankAccountsPage from "./pages/BankAccountsPage";
import PartnersPage from "./pages/PartnersPage";
import OpeningBalancesPage from "./pages/OpeningBalancesPage";
import SalesInvoicesPage from "./pages/SalesInvoicesPage";
import CreditNotesPage from "./pages/CreditNotesPage";
import { ReceiptsPage, PaymentsPage } from "./pages/VoucherPages";
import ContrasPage from "./pages/ContrasPage";
import FxGainLossPage from "./pages/FxGainLossPage";
import PurchaseInvoicesPage from "./pages/PurchaseInvoicesPage";
import ServerNameMappingsPage from "./pages/ServerNameMappingsPage";
import GeneralLedgersPage from "./pages/GeneralLedgersPage";
import JournalsPage from "./pages/JournalsPage";
import MonthlyPnLPage from "./pages/MonthlyPnLPage";
import ReportsPage from "./pages/ReportsPage";
import UsersPage from "./pages/UsersPage";
import ProfilePage from "./pages/ProfilePage";
import OverheadLedgersPage from "./pages/OverheadLedgersPage";
import EntityInvoiceSettingsPage from "./pages/EntityInvoiceSettingsPage";

function App() {
    return (
        <AuthProvider>
            <AppProvider>
                <BrowserRouter>
                    <Toaster position="top-right" richColors closeButton />
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />
                        <Route
                            element={
                                <ProtectedRoute>
                                    <Layout />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="/" element={<Navigate to="/dashboard" replace />} />
                            <Route path="/dashboard" element={<DashboardPage />} />
                            <Route path="/currencies" element={<CurrencyMasterPage />} />
                            <Route path="/entities" element={<EntitiesPage />} />
                            <Route path="/banks" element={<BankAccountsPage />} />
                            <Route path="/partners" element={<PartnersPage />} />
                            <Route path="/opening-balances" element={<OpeningBalancesPage />} />
                            <Route path="/sales-invoices" element={<SalesInvoicesPage />} />
                            <Route path="/credit-notes" element={<CreditNotesPage />} />
                            <Route path="/receipts" element={<ReceiptsPage />} />
                            <Route path="/payments" element={<PaymentsPage />} />
                            <Route path="/contras" element={<ContrasPage />} />
                            <Route path="/fx-gain-loss" element={<FxGainLossPage />} />
                            <Route path="/purchase-invoices" element={<PurchaseInvoicesPage />} />
                            <Route path="/server-name-mappings" element={<ServerNameMappingsPage />} />
                            <Route path="/general-ledgers" element={<GeneralLedgersPage />} />
                            <Route path="/journals" element={<JournalsPage />} />
                            <Route path="/monthly-pnl" element={<MonthlyPnLPage />} />
                            <Route path="/reports" element={<ReportsPage />} />
                            <Route path="/users" element={<UsersPage />} />
                            <Route path="/profile" element={<ProfilePage />} />
                            <Route path="/overhead-ledgers" element={<OverheadLedgersPage />} />
                            <Route path="/entity-invoice-settings" element={<EntityInvoiceSettingsPage />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                </BrowserRouter>
            </AppProvider>
        </AuthProvider>
    );
}

export default App;
